import { render } from "./AddInventory.vue?vue&type=template&id=0d1318f4"
import script from "./AddInventory.vue?vue&type=script&lang=js"
export * from "./AddInventory.vue?vue&type=script&lang=js"
script.render = render

export default script